export enum FeaturesEnum {
  NOTIFICATION_RULES,
  LANDING_PAGE,
  ERROR_NOTIFICATION= 'ERROR_NOTIFICATION'
}
